import Vue from 'vue'

export const EVENTS = {
  filter: {
    beforeSwitchCards: 'before-switch-cards',
  },
}

export const EventBus = new Vue()
